import {
  CREATE_TICKET_TEMPLATE,
  UPDATE_TICKET_TEMPLATE,
  UNLOAD_TICKET_TEMPLATE,
  FETCH_TICKET_TEMPLATE_LIST,
  TICKET_TEMPLATE_FETCHED_SUCCESS,
  TICKET_TEMPLATE_FETCHED_FAILED,
  TICKET_TEMPLATE_TOGGLE_STATUS,
  TICKET_TEMPLATE_TOGGLE_SUCCESS,
  TICKET_TEMPLATE_TOGGLE_FAILED,
} from '../constants/actionTypes';

const initialState = {
  templates: [],
  message: '',
  pager: {
    current: 1,
    pageSize: 15,
    total: 0,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_TICKET_TEMPLATE:
    case UPDATE_TICKET_TEMPLATE:
      return {
        ...state,
        message: action.payload.msg,
      };

    case UNLOAD_TICKET_TEMPLATE:
      return initialState;

    case TICKET_TEMPLATE_FETCHED_SUCCESS:
      return {
        ...state,
        templates: action.payload.templates,
        pager: action.payload.pager,
      };

    case TICKET_TEMPLATE_TOGGLE_SUCCESS:
      return {
        ...state,
        templates: state.templates.map((template) => {
          if (template.id !== action.payload.id) return template;
          return { ...template, is_active: action.payload.active };
        }),
      };

    case TICKET_TEMPLATE_FETCHED_FAILED:
    case FETCH_TICKET_TEMPLATE_LIST:
    case TICKET_TEMPLATE_TOGGLE_STATUS:
    case TICKET_TEMPLATE_TOGGLE_FAILED:
      return state;

    default:
      return state;
  }
};
